import React, { useState } from "react";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import MapComponent from "../../components/map";
import ActivityListComponent from "../../components/activityList";
import biosenseAPI from "../../../api/biosense";

const ProjectButton = ({ handleButtonOnClick }) => {
  return (
    <Button
      variant='contained'
      style={{ borderRadius: "4px" }}
      color={"warning"}
      onClick={() => handleButtonOnClick()}
    >
      {"查看項目"}
    </Button>
  );
};

const DashboardScreen = ({ setProjectState, setState, state, onTabChange }) => {
  const [locations, setLocations] = useState([]);
  const [activities, setActivities] = useState([]);

  async function fetchLocationData() {
    return biosenseAPI.getProjectList().then((res) =>
      setLocations(
        res.projects.map((item) => {
          return {
            position: [Number(item.lat), Number(item.lng)],
            id: item.id,
            alias: item.alias,
            img: item.img,
          };
        }),
      ),
    );
  }

  async function fetchActivitiesData() {
    return biosenseAPI.getActivityList().then((res) => setActivities(res.activities));
  }
  const handleProjectButtonOnClick = (location) => {
    const project = { id: location.id, alias: location.alias };
    setProjectState({
      selectedProject: project,
    });
    setState({
      pageTabStack: [...state.pageTabStack, state.pageTab],
      pageTab: "projects",
      pageIdxStack: [...state.pageIdxStack, state.pageIdx],
      pageIdx: state.pageIdx + 1,
    });
    onTabChange("projects", state.pageIdx + 1);
  };

  const items = [
    {
      id: 1,
      text: "",
      content: (
        <MapComponent
          locations={locations}
          fetchData={fetchLocationData}
          onLocationsClick={(location) => handleProjectButtonOnClick(location)}
          renderTooltip={(location) => {
            return (
              <Box>
                <Typography fontSize={12} color='textPrimary'>
                  {location.alias}
                </Typography>
                <Typography fontSize={10} color='textSecondary'>
                  點擊標記查看項目
                </Typography>
              </Box>
            );
          }}
        />
      ),
    },
    {
      id: 2,
      text: "",
      content: (
        <ActivityListComponent
          state={state}
          setState={setState}
          setProjectState={setProjectState}
          activities={activities}
          fetchData={fetchActivitiesData}
        />
      ),
    },
    { id: 3, text: "警告" },
    { id: 4, text: "關注圖表" },
  ];
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} lg={4}>
        {items
          .filter((_, index) => index % 2 === 0)
          .map(
            (item) =>
              item.content && (
                <Paper key={item.id} elevation={3} sx={{ p: 0, mb: 1 }}>
                  <Typography>{item.text}</Typography>
                  {item.content}
                </Paper>
              ),
          )}
      </Grid>
      <Grid item xs={12} lg={8}>
        {items
          .filter((_, index) => index % 2 === 1)
          .map(
            (item) =>
              item.content && (
                <Paper key={item.id} elevation={3} sx={{ p: 0, mb: 1 }}>
                  <Typography>{item.text}</Typography>
                  {item.content}
                </Paper>
              ),
          )}
      </Grid>
    </Grid>
  );
};

export default DashboardScreen;
